import Link from 'next/link';

interface BreadcrumbProps {
  items: { label: string; href?: string }[];
  locale?: "pt" | "en";
}

export default function Breadcrumb({ items, locale }: BreadcrumbProps) {
  const buildHref = (href: string) => {
    if (!locale) return href;
    if (href.startsWith("http://") || href.startsWith("https://")) return href;
    if (href === `/${locale}` || href.startsWith(`/${locale}/`)) return href;
    const normalized = href.startsWith("/") ? href : `/${href}`;
    return `/${locale}${normalized}`;
  };

  return (
    <nav className="mt-6 mb-6 px-4" aria-label="Breadcrumb">
      <ol className="flex items-center flex-wrap">
        {items.map((item, index) => (
          <li key={index} className="flex items-center">
            {index > 0 && (
              <span className="mx-2 text-[#1B475D]/50">›</span>
            )}

            {item.href ? (
              <Link
                href={buildHref(item.href)}
                className="text-md lg:text-lg text-[#1B475D]/80 hover:text-[#1B475D] hover:outline hover:outline-[#8EBD9D] hover:outline-1 hover:rounded px-2 font-medium transition"
              >
                {item.label}
              </Link>
            ) : (
              <span className="text-[#1B475D] text-md lg:text-lg font-semibold">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}
